import React from "react";
import { Link } from "react-router-dom";
import "./AboutUs.css";
import Seo from "../components/Seo";

const statistics = [
  {
    icon: "bi bi-people",
    value: "6,000+",
    label: "Happy Customers",
  },
  {
    icon: "bi bi-file-earmark-check",
    value: "8,000+",
    label: "Loans Sanctioned",
  },
  {
    icon: "bi bi-bank",
    value: "30+",
    label: "Lending Partners",
  },
  {
    icon: "bi bi-award",
    value: "10+",
    label: "Years of Experience",
  },
];

const services = [
  {
    image: "/images/About-img/hom.png",
    icon: "bi bi-house-door",
    title: "Home Loan",
    description:
      "Assistance for purchasing, constructing, renovating or transferring an eligible residential property loan.",
    path: "/home-loan",
  },
  {
    image: "/images/About-img/lap.png",
    icon: "bi bi-buildings",
    title: "Loan Against Property",
    description:
      "Explore secured funding options against eligible residential or commercial property.",
    path: "/loan-against-property",
  },
  {
    image: "/images/About-img/per.png",
    icon: "bi bi-person-check",
    title: "Personal Loan",
    description:
      "Compare suitable personal-loan options for eligible financial requirements.",
    path: "/personal-loan",
  },
  {
    image: "/images/About-img/bus.png",
    icon: "bi bi-briefcase",
    title: "Business Loan",
    description:
      "Funding assistance for working capital, expansion, inventory and business requirements.",
    path: "/business-loan",
  },
  {
    image: "/images/About-img/car.png",
    icon: "bi bi-car-front",
    title: "Car Loan",
    description:
      "Explore suitable financing options for purchasing an eligible new or used vehicle.",
    path: "/car-loan",
  },
  {
    image: "/images/About-img/edu.png",
    icon: "bi bi-mortarboard",
    title: "Education Loan",
    description:
      "Financial assistance for eligible tuition and education-related expenses.",
    path: "/education-loan",
  },
];

const storyTimeline = [
  {
    year: "2015",
    title: "Our Journey Began",
    description:
      "Started with a vision to simplify the home-loan process and provide professional assistance to borrowers.",
  },
  {
    year: "2018",
    title: "Expanded Loan Services",
    description:
      "Extended assistance to Loan Against Property and additional secured financial products.",
  },
  {
    year: "2020",
    title: "Customer Growth",
    description:
      "Reached an important milestone by assisting more than 1,000 customers.",
  },
  {
    year: "2023",
    title: "₹200+ Crore Milestone",
    description:
      "Crossed ₹200 crore in loan disbursement assistance across multiple lending partners.",
  },
];

const teamMembers = [
  {
    name: "Kishan Rathod",
    role: "Managing Director",
    image: "/images/team/kishan.png",
  },
  {
    name: "Manisha Rathod",
    role: "Director & HR Head",
    image: "/images/team/manisha.png",
  },
];

const companyValues = [
  {
    icon: "bi bi-eye",
    title: "Transparency",
    description:
      "Clear communication about eligibility, documentation, lender requirements and applicable terms.",
  },
  {
    icon: "bi bi-person-heart",
    title: "Customer-Focused Support",
    description:
      "Every customer receives guidance based on their financial profile and loan requirement.",
  },
  {
    icon: "bi bi-shield-check",
    title: "Responsible Assistance",
    description:
      "We help applicants understand suitable options without guaranteeing lender approval.",
  },
];

const AboutUs = () => {
  return (
    <>
      <Seo
        title="About MONAYRA | Trusted Loan Assistance in Pune"
        description="Learn about MONAYRA (OPC) PRIVATE LIMITED, a loan assistance company in Pune supporting home loans, Loan Against Property, personal loans, car loans and business loans."
        keywords="about MONAYRA, loan assistance Pune, home loan consultant Pune, Loan Against Property Pune, business loan assistance"
        canonical="https://www.mortbuzz.in/about-us"
      />

      <main className="monayra-about-page">
        <section className="about-page-hero">
          <div className="about-page-hero-overlay"></div>

          <div
            className="about-page-glow about-page-glow-left"
            aria-hidden="true"
          ></div>

          <div
            className="about-page-glow about-page-glow-right"
            aria-hidden="true"
          ></div>

          <div className="about-page-container about-page-hero-grid">
            <div className="about-page-hero-content">
              <span className="about-page-eyebrow">
                About MONAYRA
              </span>

              <h1>
                Your trusted partner for a
                <span> simpler loan journey</span>
              </h1>

              <p>
                MONAYRA (OPC) PRIVATE LIMITED helps individuals and
                businesses explore suitable lending options with professional
                support for eligibility, documentation, application
                processing and disbursement.
              </p>

              <div className="about-page-hero-actions">
                <Link
                  to="/apply-now"
                  className="about-page-primary-btn"
                >
                  Apply for a Loan
                  <i className="bi bi-arrow-right"></i>
                </Link>

                <Link
                  to="/contact"
                  className="about-page-secondary-btn"
                >
                  <i className="bi bi-headset"></i>
                  Contact Our Team
                </Link>
              </div>

              <div className="about-page-hero-features">
                <div>
                  <i className="bi bi-bank"></i>
                  Multiple lending partners
                </div>

                <div>
                  <i className="bi bi-file-earmark-check"></i>
                  Documentation assistance
                </div>

                <div>
                  <i className="bi bi-shield-check"></i>
                  Transparent support
                </div>
              </div>
            </div>

            <div className="about-page-hero-image">
              <img
                src="/images/Bank Pages/about-us-image.png"
                alt="MONAYRA loan assistance team"
              />

              <div className="about-page-image-overlay"></div>

              <div className="about-page-image-card">
                <span>
                  <i className="bi bi-award"></i>
                </span>

                <div>
                  <strong>10+ Years</strong>
                  <small>Loan assistance experience</small>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="about-page-who-section">
          <div className="about-page-container">
            <div className="about-page-section-header">
              <span className="about-page-eyebrow">
                Who We Are
              </span>

              <h2>
                Professional financial assistance built on
                <span> trust and transparency</span>
              </h2>

              <p>
                We connect eligible borrowers with selected banks and
                financial institutions while assisting throughout the
                application journey.
              </p>
            </div>

            <div className="about-page-who-grid">
              <article className="about-page-who-card">
                <span className="about-page-card-icon">
                  <i className="bi bi-building-check"></i>
                </span>

                <h3>Loan Assistance Company</h3>

                <p>
                  MONAYRA (OPC) PRIVATE LIMITED is a financial assistance
                  company based in Pune, supporting customers with home loans,
                  Loan Against Property, personal loans, business loans and
                  other eligible loan products.
                </p>
              </article>

              <article className="about-page-who-card">
                <span className="about-page-card-icon">
                  <i className="bi bi-diagram-3"></i>
                </span>

                <h3>Connecting Customers and Lenders</h3>

                <p>
                  We help bridge the gap between borrowers and lenders by
                  supporting eligibility reviews, document preparation,
                  lender comparison and regular application follow-ups.
                </p>
              </article>

              <article className="about-page-who-card">
                <span className="about-page-card-icon">
                  <i className="bi bi-headset"></i>
                </span>

                <h3>End-to-End Assistance</h3>

                <p>
                  Our team supports customers from initial enquiry and
                  documentation through bank submission, verification,
                  sanction and final disbursement.
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className="about-page-stats-section">
          <div className="about-page-container">
            <div className="about-page-stats-grid">
              {statistics.map((stat) => (
                <article
                  className="about-page-stat-card"
                  key={stat.label}
                >
                  <span className="about-page-stat-icon">
                    <i className={stat.icon}></i>
                  </span>

                  <strong>{stat.value}</strong>
                  <p>{stat.label}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="about-page-services-section">
          <div className="about-page-container">
            <div className="about-page-section-header">
              <span className="about-page-eyebrow">
                Our Loan Products
              </span>

              <h2>
                Financial solutions for
                <span> different requirements</span>
              </h2>

              <p>
                Explore our core loan-assistance services for individuals,
                professionals and businesses.
              </p>
            </div>

            <div className="about-page-services-grid">
              {services.map((service) => (
                <article
                  className="about-page-service-card"
                  key={service.title}
                >
                  <div className="about-page-service-image">
                    <img
                      src={service.image}
                      alt={service.title}
                      loading="lazy"
                    />
                  </div>

                  <span className="about-page-service-icon">
                    <i className={service.icon}></i>
                  </span>

                  <h3>{service.title}</h3>
                  <p>{service.description}</p>

                  <Link to={service.path}>
                    Explore Service
                    <i className="bi bi-arrow-right"></i>
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="about-page-story-section">
          <div className="about-page-container about-page-story-grid">
            <div className="about-page-story-content">
              <span className="about-page-eyebrow">
                Our Story
              </span>

              <h2>
                A journey focused on making
                <span> loan assistance simpler</span>
              </h2>

              <p>
                Our journey began in 2015 with a simple goal: to help
                customers navigate loan processes with greater clarity,
                convenience and professional support.
              </p>

              <p>
                Over the years, we expanded our services, strengthened our
                lending network and built a team committed to helping
                customers understand their available financing options.
              </p>

              <div className="about-page-story-highlight">
                <i className="bi bi-quote"></i>

                <p>
                  Our aim is to make every loan journey more organised,
                  transparent and customer-focused.
                </p>
              </div>
            </div>

            <div className="about-page-timeline">
              {storyTimeline.map((item) => (
                <article
                  className="about-page-timeline-item"
                  key={item.year}
                >
                  <span className="about-page-timeline-year">
                    {item.year}
                  </span>

                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="about-page-values-section">
          <div className="about-page-container">
            <div className="about-page-section-header">
              <span className="about-page-eyebrow">
                Our Values
              </span>

              <h2>
                Principles that guide
                <span> how we work</span>
              </h2>
            </div>

            <div className="about-page-values-grid">
              {companyValues.map((value) => (
                <article
                  className="about-page-value-card"
                  key={value.title}
                >
                  <span>
                    <i className={value.icon}></i>
                  </span>

                  <h3>{value.title}</h3>
                  <p>{value.description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="about-page-team-section">
          <div className="about-page-container">
            <div className="about-page-section-header">
              <span className="about-page-eyebrow">
                Our Leadership
              </span>

              <h2>
                Meet the people behind
                <span> MONAYRA</span>
              </h2>

              <p>
                Leadership focused on customer support, professional service
                and responsible business growth.
              </p>
            </div>

            <div className="about-page-team-grid">
              {teamMembers.map((member) => (
                <article
                  className="about-page-team-card"
                  key={member.name}
                >
                  <div className="about-page-team-image">
                    <img
                      src={member.image}
                      alt={member.name}
                      loading="lazy"
                    />

                    <div className="about-page-team-image-overlay"></div>
                  </div>

                  <div className="about-page-team-info">
                    <h3>{member.name}</h3>
                    <p>{member.role}</p>

                    <span>
                      <i className="bi bi-patch-check-fill"></i>
                      Leadership Team
                    </span>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="about-page-contact-section">
          <div className="about-page-container">
            <div className="about-page-contact-card">
              <div>
                <span className="about-page-eyebrow">
                  Let’s Begin
                </span>

                <h2>Let’s build your financial future together</h2>

                <p>
                  Whether you are purchasing a home, transferring an existing
                  loan or arranging business finance, our team is ready to
                  assist you.
                </p>
              </div>

              <div className="about-page-contact-actions">
                <a
                  href="tel:18002104422"
                  className="about-page-primary-btn"
                >
                  <i className="bi bi-telephone"></i>
                  1800 210 4422
                </a>

                <a
                  href="mailto:contact@mortbuzz.in"
                  className="about-page-secondary-btn"
                >
                  <i className="bi bi-envelope"></i>
                  Email Our Team
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="about-page-disclaimer">
          <div className="about-page-container">
            <i className="bi bi-info-circle"></i>

            <p>
              MONAYRA (OPC) PRIVATE LIMITED provides loan assistance and
              facilitates applications with selected lending institutions.
              Final approval, interest rates, loan amount, tenure and charges
              are determined by the lender based on its policies and the
              applicant’s eligibility.
            </p>
          </div>
        </section>
      </main>
    </>
  );
};

export default AboutUs;